import { render, staticRenderFns } from "./addImeis.vue?vue&type=template&id=52211642&"
import script from "./addImeis.vue?vue&type=script&lang=js&"
export * from "./addImeis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports